import Vue from "vue";
import Router from "vue-router";
import VueHead from 'vue-head';
import store from "@/store";

Vue.use(VueHead);
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/404",
      component: () =>
        import(/* webpackChunkName: "notFound" */ "@/views/NotFound.vue")
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      path: "/",
      redirect: "/dashboard"
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: () =>
        import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/offer",
      redirect: "/dashboard"
    },
    {
      path: "/offer/:id",
      name: "offer",
      component: () =>
        import(/* webpackChunkName: "offer" */ "@/views/Offer.vue"),
      meta: {
        requiresAuth: true
      },
      props: true
    },
    {
      path: "/parcels",
      name: "parcels",
      component: () =>
        import(/* webpackChunkName: "parcels" */ "@/views/Parcels.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/parcels/:id",
      name: "parcel",
      component: () =>
        import(/* webpackChunkName: "parcel" */ "@/views/Parcel.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/project/:id",
      name: "project",
      component: () =>
        import(/* webpackChunkName: "project" */ "@/views/Project.vue"),
      meta: {
        requiresAuth: true
      },
      props: true
    },
    {
      path: "/presentation/:uuid",
      name: "presentation",
      component: () =>
        import(/* webpackChunkName: "presentation" */ "@/views/Presentation.vue"),
      beforeEnter: async (to, from, next) => {
        try {
          const response = await store.dispatch("checkPassword", {
            uuid: to.params.uuid,
            password: ""
          });
          if (response.status === 200) {
            next();
          } else {
            next("/404");
          }
        } catch (e) {
          next("/404");
        }
      }
    },
    {
      path: "/settings",
      name: "settings",
      component: () =>
        import(/* webpackChunkName: "settings" */ "@/views/Settings.vue"),
      meta: {
        requiresAuth: true
      },
      props: true
    },
    {
      path: "/statistics",
      name: "statistics",
      component: () =>
        import(/* webpackChunkName: "statistics" */ "@/views/Statistics.vue"),
      meta: {
        requiresAuth: true
      },
      props: true
    },
    {
      path: "/help",
      name: "help",
      component: () =>
        import(/* webpackChunkName: "help" */ "@/views/Help.vue"),
      meta: {
        requiresAuth: true
      },
      props: true
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "@/views/Login.vue")
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.getLogged) {
      store
        .dispatch("checkToken")
        .then(() => {
          next();
        })
        .catch(() => {
          next({
            name: "login"
          });
        });
    } else {
      next();
    }
  } else if (to.name === "presentation") {
    store
      .dispatch("checkToken")
      .then(() => {
        // User zalogowany na widoku prezentacji
        next();
      })
      .catch(() => {
        // User niezalogowany na widoku prezentacji
        next();
      });
  } else {
    next();
  }
});

export default router;
